<template>
  <div>
    <base-info-card :title="title" :subtitle="subtitle" space="4" color="primary" />

    <base-text-field label="Тема" @input="updateSubject" />
    <base-textarea class="mb-6" label="Сообщение" @input="updateMessage" />

    <base-btn
      :color="!theme.isDark ? 'accent' : 'white'"
      :href="href"
      outlined
      target="_blank"
    >
      Отправить
    </base-btn>
  </div>
</template>

<script>
  export default {
    name: 'BaseContactForm',
    // Injected from the Vuetify Themeable mixin
    inject: ['theme'],
    props: {
      subtitle: String,
      title: {
        type: String,
        default: 'MAIL US YOUR MESSAGE',
      }
    },
    data: () => ({
      subject: 'вопрос с сайта',
      message: ''
    }),
    computed: {
      href() {
        return `mailto:p.engi@mail.ru?subject=${this.subject}&body=${this.message}`
      }
    },
    methods: {
      updateSubject(val) {
        this.subject = val
      },
      updateMessage(val) {
        this.message = val
      },
    }
  }
</script>
